import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionStatesCardComponent } from './transaction-states-card.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { TransactionStatesStepperModule } from '../transaction-states-stepper/transaction-states-stepper.module';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
    declarations: [TransactionStatesCardComponent],
    exports: [TransactionStatesCardComponent],
    imports: [CommonModule, MatCardModule, MatStepperModule, MatIconModule, TransactionStatesStepperModule, MatProgressSpinnerModule]
})
export class TransactionStatesCardModule {}
